/**
 * 禁用右键菜单（不弹窗、不交卷；仅降低另存为/检查等入口，无法阻止 F12）。
 */
const handleContextMenu = (e) => {
  e.preventDefault();
};

/**
 * @param {{ getActive: () => boolean }} ctx
 * @returns {{ attach: () => void; detach: () => void }}
 */
export function createContextMenuGuard(ctx) {
  const wrapped = (e) => {
    if (ctx.getActive()) handleContextMenu(e);
  };

  return {
    attach() {
      window.addEventListener("contextmenu", wrapped, true);
    },
    detach() {
      window.removeEventListener("contextmenu", wrapped, true);
    },
  };
}
